import { formatCell, formatLoadingCell } from '../utils/formatCell';
import { useMemo } from 'react';
import { usePortalData } from '../data/usePortalData';
export const useTicketListingsColumns = (isLoading, isGrid = false) => {
  const {
    data
  } = usePortalData();
  return useMemo(() => data === null || data === void 0 ? void 0 : data.configuredTicketProperties.map(x => x).sort((a, b) => a.displayOrder - b.displayOrder).map(property => {
    const {
      displayNameOverride,
      propertyName
    } = property;
    return {
      id: propertyName,
      accessorKey: propertyName,
      header: displayNameOverride || propertyName,
      cell: isLoading ? formatLoadingCell(property) : formatCell(property, isGrid)
    };
  }), [data === null || data === void 0 ? void 0 : data.configuredTicketProperties, isLoading, isGrid]) || [];
};